export const translations = {
  en: {
    lang: "EN",
    nav: {
      joinWaitlist: "Join Waitlist",
    },
    hero: {
      badge: "Now in private beta · Founders only",
      headline1: "The Purpose-Built Merchant CRM for",
      headline2: "Shopify App Founders",
      subheadline:
        "Appdesh gives you a unified view of your merchants, revenue, and support — so you can grow your Shopify app without stitching together five tools.",
      emailPlaceholder: "Work email",
      cta: "Get Early Access",
      hint: "Setup in 15 min · No spam · Unsubscribe anytime",
      successTitle: "You're on the list!",
      successBody: "We'll reach out personally to onboard you.",
    },
    stats: {
      founders: "App founders on the waitlist",
      revenue: "Partner revenue tracked",
      setup: "Average setup time",
    },
    features: {
      heading: "Everything a Shopify App Partner needs",
      subheading:
        "Stop context-switching between five tools. Appdesh brings your apps, merchants, and support into one focused workspace.",
      items: [
        {
          tagline: "Know your unit economics",
          title: "Revenue & App Analytics",
          description:
            "Sync your Shopify Partner API automatically. Track MRR, churn, and app performance across all your apps — no spreadsheets.",
        },
        {
          tagline: "Know your customers",
          title: "Merchant CRM",
          description:
            "A complete view of every merchant using your app — plan, install date, activity, and notes. Stop guessing who might churn.",
        },
        {
          tagline: "Reply faster, retain more",
          title: "Support Tickets",
          description:
            "Built-in ticket system for your app customers. Track issues, respond quickly, and keep merchants happy without leaving Appdesh.",
        },
        {
          tagline: "Turn happy merchants into reviews",
          title: "Review Management",
          description:
            "Generate review links per app and send targeted requests to your happiest merchants. Grow your star rating systematically.",
        },
      ],
    },
    cta: {
      heading: "Ready to grow your Shopify app?",
      subheading: "We onboard partners one by one. Apply early — spots are limited.",
      emailPlaceholder: "Work email",
      cta: "Get Early Access (founders only)",
      hint: "Setup in 15 min · No credit card required",
      successTitle: "You're on the list!",
      successBody: "Expect a personal email from us soon.",
    },
    footer: {
      legal: "Legal Notice",
      rights: "All rights reserved.",
    },
  },

  de: {
    lang: "DE",
    nav: {
      joinWaitlist: "Warteliste beitreten",
    },
    hero: {
      badge: "Jetzt in privater Beta · Nur für Gründer",
      headline1: "Das speziell entwickelte Merchant-CRM für",
      headline2: "Shopify-App-Gründer",
      subheadline:
        "Appdesh gibt Ihnen eine einheitliche Übersicht über Ihre Händler, Einnahmen und Support — damit Sie Ihre Shopify-App wachsen lassen können, ohne fünf Tools zu verbinden.",
      emailPlaceholder: "Geschäftliche E-Mail",
      cta: "Frühen Zugang erhalten",
      hint: "Einrichtung in 15 Min. · Kein Spam · Jederzeit abmeldbar",
      successTitle: "Sie stehen auf der Liste!",
      successBody: "Wir melden uns persönlich bei Ihnen.",
    },
    stats: {
      founders: "App-Gründer auf der Warteliste",
      revenue: "Partnerumsatz verfolgt",
      setup: "Durchschnittliche Einrichtungszeit",
    },
    features: {
      heading: "Alles, was ein Shopify-App-Partner braucht",
      subheading:
        "Hören Sie auf, zwischen fünf Tools hin- und herzuspringen. Appdesh bringt Ihre Apps, Händler und Support in einen fokussierten Arbeitsbereich.",
      items: [
        {
          tagline: "Verstehen Sie Ihre Wirtschaftlichkeit",
          title: "Umsatz- & App-Analysen",
          description:
            "Synchronisieren Sie die Shopify-Partner-API automatisch. Verfolgen Sie MRR, Abwanderung und App-Performance ohne Tabellenkalkulationen.",
        },
        {
          tagline: "Kennen Sie Ihre Kunden",
          title: "Händler-CRM",
          description:
            "Vollständige Übersicht über jeden Händler — Plan, Installationsdatum, Aktivität und Notizen. Hören Sie auf zu raten, wer abwandern könnte.",
        },
        {
          tagline: "Schneller antworten, mehr binden",
          title: "Support-Tickets",
          description:
            "Integriertes Ticket-System für Ihre App-Kunden. Verfolgen Sie Probleme und halten Sie Händler zufrieden, ohne Appdesh zu verlassen.",
        },
        {
          tagline: "Glückliche Händler in Bewertungen umwandeln",
          title: "Bewertungsmanagement",
          description:
            "Erstellen Sie Bewertungslinks pro App und senden Sie gezielte Anfragen an Ihre zufriedensten Händler. Verbessern Sie Ihre Sternebewertung systematisch.",
        },
      ],
    },
    cta: {
      heading: "Bereit, Ihre Shopify-App zu vergrößern?",
      subheading: "Wir nehmen Partner einzeln an Bord. Bewerben Sie sich früh — Plätze sind begrenzt.",
      emailPlaceholder: "Geschäftliche E-Mail",
      cta: "Frühen Zugang erhalten (nur Gründer)",
      hint: "Einrichtung in 15 Min. · Keine Kreditkarte erforderlich",
      successTitle: "Sie stehen auf der Liste!",
      successBody: "Erwarten Sie bald eine persönliche E-Mail von uns.",
    },
    footer: {
      legal: "Impressum",
      rights: "Alle Rechte vorbehalten.",
    },
  },

  fr: {
    lang: "FR",
    nav: {
      joinWaitlist: "Rejoindre la liste",
    },
    hero: {
      badge: "Maintenant en bêta privée · Fondateurs uniquement",
      headline1: "Le CRM Marchand conçu pour les",
      headline2: "fondateurs d'applications Shopify",
      subheadline:
        "Appdesh vous offre une vue unifiée de vos marchands, revenus et support — pour développer votre application Shopify sans jongler entre cinq outils.",
      emailPlaceholder: "E-mail professionnel",
      cta: "Obtenir un accès anticipé",
      hint: "Installation en 15 min · Sans spam · Désinscription possible",
      successTitle: "Vous êtes sur la liste !",
      successBody: "Nous vous contacterons personnellement pour vous intégrer.",
    },
    stats: {
      founders: "Fondateurs d'applications sur la liste",
      revenue: "Revenus partenaires suivis",
      setup: "Temps d'installation moyen",
    },
    features: {
      heading: "Tout ce dont un partenaire d'application Shopify a besoin",
      subheading:
        "Arrêtez de jongler entre cinq outils. Appdesh réunit vos applications, marchands et support dans un espace de travail unique.",
      items: [
        {
          tagline: "Maîtrisez votre économie unitaire",
          title: "Revenus & Analyses d'applications",
          description:
            "Synchronisez automatiquement votre API Shopify Partner. Suivez le MRR, le churn et les performances de vos applications sans tableurs.",
        },
        {
          tagline: "Connaissez vos clients",
          title: "CRM Marchand",
          description:
            "Vue complète de chaque marchand utilisant votre application — plan, date d'installation, activité et notes. Anticipez le churn.",
        },
        {
          tagline: "Répondez vite, fidélisez plus",
          title: "Tickets de support",
          description:
            "Système de tickets intégré pour vos clients. Suivez les problèmes et gardez les marchands satisfaits sans quitter Appdesh.",
        },
        {
          tagline: "Transformez les marchands en avis",
          title: "Gestion des avis",
          description:
            "Générez des liens d'avis par application et envoyez des demandes ciblées à vos marchands les plus satisfaits. Améliorez votre note.",
        },
      ],
    },
    cta: {
      heading: "Prêt à développer votre application Shopify ?",
      subheading: "Nous intégrons les partenaires un par un. Candidatez tôt — les places sont limitées.",
      emailPlaceholder: "E-mail professionnel",
      cta: "Accès anticipé (fondateurs uniquement)",
      hint: "Installation en 15 min · Aucune carte bancaire requise",
      successTitle: "Vous êtes sur la liste !",
      successBody: "Attendez un e-mail personnel de notre part bientôt.",
    },
    footer: {
      legal: "Mentions légales",
      rights: "Tous droits réservés.",
    },
  },

  bn: {
    lang: "বাং",
    nav: {
      joinWaitlist: "অপেক্ষা তালিকায় যোগ দিন",
    },
    hero: {
      badge: "এখন প্রাইভেট বেটায় · শুধু প্রতিষ্ঠাতাদের জন্য",
      headline1: "Shopify অ্যাপ প্রতিষ্ঠাতাদের জন্য",
      headline2: "বিশেষভাবে তৈরি মার্চেন্ট CRM",
      subheadline:
        "Appdesh আপনাকে আপনার মার্চেন্ট, রাজস্ব এবং সাপোর্টের একটি সমন্বিত দৃশ্য দেয় — পাঁচটি টুল জোড়া না লাগিয়েই আপনার Shopify অ্যাপ বাড়াতে পারবেন।",
      emailPlaceholder: "কর্মক্ষেত্রের ইমেইল",
      cta: "আর্লি অ্যাক্সেস পান",
      hint: "১৫ মিনিটে সেটআপ · কোনো স্প্যাম নেই · যেকোনো সময় আনসাবস্ক্রাইব করুন",
      successTitle: "আপনি তালিকায় আছেন!",
      successBody: "আমরা ব্যক্তিগতভাবে আপনার সাথে যোগাযোগ করব।",
    },
    stats: {
      founders: "অপেক্ষা তালিকায় অ্যাপ প্রতিষ্ঠাতা",
      revenue: "পার্টনার রাজস্ব ট্র্যাক করা হয়েছে",
      setup: "গড় সেটআপ সময়",
    },
    features: {
      heading: "Shopify অ্যাপ পার্টনারের যা দরকার সবই আছে",
      subheading:
        "পাঁচটি টুলের মধ্যে ঘুরে বেড়ানো বন্ধ করুন। Appdesh আপনার অ্যাপ, মার্চেন্ট এবং সাপোর্ট একটি কেন্দ্রীভূত কর্মক্ষেত্রে নিয়ে আসে।",
      items: [
        {
          tagline: "আপনার ইউনিট ইকোনমিক্স জানুন",
          title: "রাজস্ব ও অ্যাপ বিশ্লেষণ",
          description:
            "স্বয়ংক্রিয়ভাবে Shopify Partner API সিঙ্ক করুন। স্প্রেডশিট ছাড়াই MRR, চার্ন এবং অ্যাপ পারফরম্যান্স ট্র্যাক করুন।",
        },
        {
          tagline: "আপনার গ্রাহকদের জানুন",
          title: "মার্চেন্ট CRM",
          description:
            "প্রতিটি মার্চেন্টের সম্পূর্ণ দৃশ্য — প্ল্যান, ইনস্টল তারিখ, কার্যকলাপ এবং নোট। কে চার্ন করবে তা আর অনুমান করতে হবে না।",
        },
        {
          tagline: "দ্রুত উত্তর দিন, বেশি ধরে রাখুন",
          title: "সাপোর্ট টিকেট",
          description:
            "আপনার অ্যাপ গ্রাহকদের জন্য বিল্ট-ইন টিকেট সিস্টেম। Appdesh না ছেড়েই সমস্যা ট্র্যাক করুন এবং মার্চেন্টদের সন্তুষ্ট রাখুন।",
        },
        {
          tagline: "সুখী মার্চেন্টকে রিভিউতে পরিণত করুন",
          title: "রিভিউ ম্যানেজমেন্ট",
          description:
            "প্রতিটি অ্যাপের জন্য রিভিউ লিঙ্ক তৈরি করুন এবং সবচেয়ে সন্তুষ্ট মার্চেন্টদের কাছে লক্ষ্যভিত্তিক অনুরোধ পাঠান।",
        },
      ],
    },
    cta: {
      heading: "আপনার Shopify অ্যাপ বাড়াতে প্রস্তুত?",
      subheading: "আমরা একে একে পার্টনার অনবোর্ড করি। তাড়াতাড়ি আবেদন করুন — জায়গা সীমিত।",
      emailPlaceholder: "কর্মক্ষেত্রের ইমেইল",
      cta: "আর্লি অ্যাক্সেস পান (শুধু প্রতিষ্ঠাতা)",
      hint: "১৫ মিনিটে সেটআপ · ক্রেডিট কার্ড লাগবে না",
      successTitle: "আপনি তালিকায় আছেন!",
      successBody: "শীঘ্রই আমাদের কাছ থেকে একটি ব্যক্তিগত ইমেইল আশা করুন।",
    },
    footer: {
      legal: "আইনি বিজ্ঞপ্তি",
      rights: "সর্বস্বত্ব সংরক্ষিত।",
    },
  },
}
